// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"MainMenu__mainMenu","active":"MainMenu__active","primaryNav":"MainMenu__primaryNav","secondaryNav":"MainMenu__secondaryNav"};